import { store } from '@/store'
import { ModuleName } from '@/store/modules/createWarehouseReceivingOrder'
import { machine } from '@/models/createWarehouseReceivingOrder/create-order-machine'
import PackagingTypesEnum from '@enums/modules/creatingWarehouseReceivingOrder/packagingType'

export const resetEstimatedArrivalDate = () => store.dispatch(ModuleName + '/resetEstimatedDateOfArrival')

export const resetBillOfLading = () => store.dispatch(ModuleName + '/resetBillOfLading')

const isValidDateEntered = (date) => {
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0, 0)
  const isDateValid = !isNaN(Date.parse(date)) // Date.parse will return NaN for an invalid date
  const isDateInPast = isDateValid && (new Date(date).toISOString() >= currentDate.toISOString())
  return (isDateInPast && isDateValid)
}

export const decideState = () => {
  const estimatedArrivalDate = store.getters[ModuleName + '/estimatedArrivalDate']
  const isValidDate = isValidDateEntered(estimatedArrivalDate)
  const pricingGroup = store.getters[ModuleName + '/pricingGroup']
  if (estimatedArrivalDate && isValidDate) machine.transition('GOOD')
  else if (pricingGroup && pricingGroup.id) machine.transition('GOOD')
  else machine.transition('BAD')
}

export const clearLabelSelection = () => {
  const pricingGroup = store.getters[ModuleName + '/pricingGroup']
  if (pricingGroup && !pricingGroup.id) {
    store.dispatch(ModuleName + '/setSelectedLabelPurchaseType', PackagingTypesEnum.labelPurchaseTypes[1])
  }
}

export const clearArrivalDetailsForEditWro = () => {
  resetEstimatedArrivalDate()
  resetBillOfLading()
}

export const resetArrivalDetailsForDraft = () => {
  const isWroCreated = store.getters[ModuleName + '/isWroCreated']
  if (!isWroCreated) {
    resetEstimatedArrivalDate()
    resetBillOfLading()
  }
}
